// src/js/main/order.js

import { DOMElements, initializeDOMElements } from '../config/dom.js';
import { populateConfigSelect } from '../config/ui/populateConfigSelect.js';
import { hideMessage } from '../config/ui/showMessage.js';
import { toggleConfigurationSource } from '../config/ui/toggleConfigurationSource.js';
import { loadAndDisplayConfiguration } from '../config/ui/loadAndDisplayConfiguration.js';
import { toggleConfigTableVisibility } from '../config/ui/toggleConfigTableVisibility.js';
import { handleSendOrderClick } from '../config/sendOrder.js';

function setupOrderEventListeners() {
    const { selectConfig, configFileUpload, fileNameDisplay, orderConfigSourceRadios, showBtn, sendOrderBtn } = DOMElements;

    if (selectConfig) {
        selectConfig.addEventListener('change', () => {
            loadAndDisplayConfiguration('select', selectConfig.value);
        });
    }
    if (configFileUpload) {
        configFileUpload.addEventListener('change', (event) => {
            hideMessage();
            const file = event.target.files[0];
            if (fileNameDisplay) fileNameDisplay.textContent = file ? file.name : 'No file chosen';
            loadAndDisplayConfiguration(file ? 'upload' : 'select', file || 'default');
        });
    }
    if (orderConfigSourceRadios) {
        orderConfigSourceRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                toggleConfigurationSource(radio.value);
                loadAndDisplayConfiguration('select', 'default');
            });
        });
    }
    if (showBtn) {
        showBtn.addEventListener('click', toggleConfigTableVisibility);
    }
    if (sendOrderBtn) {
        sendOrderBtn.addEventListener('click', handleSendOrderClick);
    }
}

// Körs FÖRST: Förbered allt.
document.addEventListener('DOMContentLoaded', () => {
    initializeDOMElements();
    populateConfigSelect();
    setupOrderEventListeners();

    // Sätt sidans slutgiltiga tillstånd (flyttat från window.load för att undvika 2s väntetid på recaptcha/bilder)
    const savedSource = localStorage.getItem('selectedPackageSource') || 'select';
    const radioToSelect = document.querySelector(`input[name="config-source"][value="${savedSource}"]`);
    if (radioToSelect) {
        radioToSelect.checked = true;
    }
    toggleConfigurationSource(savedSource);

    const configToSelect = localStorage.getItem('selectedConfigOnOrderPage');

    if (configToSelect) {
        // FALL 1: Vi kommer från "Gå vidare"-flödet.
        console.log('Proceed-to-order flow detected. Pre-selecting configuration.');
        
        const { selectConfig } = DOMElements;
        const optionExists = Array.from(selectConfig.options).some(option => option.value === configToSelect);

        if (optionExists) {
            selectConfig.value = configToSelect;
            selectConfig.dispatchEvent(new Event('change'));
        }
        localStorage.removeItem('selectedConfigOnOrderPage');
    } else {
        // FALL 2: Normal sidladdning eller "bakåt"-navigering. Återställ.
        console.log('Normal page load or back-navigation detected. Resetting UI.');
        
        const { selectConfig } = DOMElements;
        if (selectConfig.value !== 'default') {
            selectConfig.value = 'default';
            selectConfig.dispatchEvent(new Event('change'));
        }
    }
});